<template>
  <div class="fullscreen-video-container">
    <div class="skip" @click="next">跳&nbsp;过</div>
    <div class="video-container">
      <!-- <img src="../new-assets/play.png" class="play-icon" alt="" /> -->
      <video
        src="https://jcdn.xhby.net/project/xiaokang/video/start.mp4"
        poster="https://jcdn.xhby.net/project/xiaokang/assets/welcome/poster.png"
        @ended="next"
        controls="controls"
        autoplay
      ></video>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
};
</script>


<style scoped lang="less">
.fullscreen-video-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: url("../assets/app/01bg.jpg");
  background-size: cover;
  background-position: 50% 50%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .video-container {
    // width: 75vw;
    // height: 80vh;
    width: 100vw;
    height: 100vh;
    position: relative;

    .play-icon {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 10vw;
      height: 10vw;
    }

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      outline-width: 0;
    }
  }

  .skip {
    padding: 10px 20px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    position: absolute;
    right: 20px;
    top: 20px;
    border-radius: 10px;
    z-index: 100;
    cursor: pointer;
  }
}
</style>